import CouponImage from '../../../public/coupon.png';
import { Bubble, Props } from './Bubble';
import dayjs from 'dayjs';
import Image from 'next/image';
import { Link } from '../../Link';

export const CouponBubble = (props: Props) => {
  const url = props.message.data['planId']
    ? `${props.isPhone ? '/phone' : ''}/tellers/${props.message.data['teller']['id']}/plans/${
        props.message.data['planId']
      }?type=chat&context=counsel&code=${props.message.data['couponCode']['code']}`
    : `${props.isPhone ? '/phone' : ''}/tellers/${
        props.message.data['teller']['id']
      }?type=chat&context=counsel&code=${props.message.data['couponCode']['code']}`;

  return (
    <Bubble {...props}>
      <div className="rounded-2xl border bg-white drop-shadow-sm">
        <Image src={CouponImage} alt="" width={514} height={342} />
        <p className="mx-4 text-lg font-semibold">
          {props.message.data['teller']['name']}先生専用クーポン
        </p>
        <p className="mx-4 mt-1 border-b-2 border-dotted border-black pb-2 text-sm">
          {props.message.data['teller']['name']}の鑑定メニューを購入する際にご利用いただけます
        </p>
        <p className="mx-4 my-2 text-center text-lg font-semibold">
          {props.message.data['coupon']['type'] === 'scheduled' &&
            dayjs(
              props.message.data['coupon']['endTime'] instanceof Date
                ? props.message.data['coupon']['endTime']
                : props.message.data['coupon']['endTime'].toDate(),
            ).format('YYYY年MM月DD日') + 'まで'}
          {props.message.data['coupon']['type'] === 'limited' &&
            props.message.data['coupon']['availableDays'] + '日間有効'}
        </p>
        <Link
          href={url}
          className="mx-4 mb-4 block cursor-pointer rounded-xl bg-[#ED70C0] py-2 text-center text-lg font-semibold text-white"
        >
          クーポンを受け取る
        </Link>
      </div>
    </Bubble>
  );
};
